package com.starparty.app.astro0.js

import copyrightDates
import MORE_INFO_WEBPAGE
import VERSION
import com.starparty.app.astro0.Controls
import com.starparty.app.astro0.MathD
import com.starparty.app.astro0.Sky
import com.starparty.app.astro0.UMS
import com.starparty.app.astro0.event.SP_TimeEvent
import com.starparty.app.astro0.event.SP_TimeListener
import com.starparty.app.astro0.events.SearchHandler
import createTime
import dateTime
import initialiseDateTime
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.*
import org.w3c.dom.events.Event
import org.w3c.dom.events.KeyboardEvent
import toTimeStamp
import kotlin.js.Date
import kotlin.math.abs
import kotlin.math.absoluteValue
import kotlin.math.PI

class SP_JSControls(val sky: Sky, val cs:SP_JSSkyViewCanvasState,
                    val clock: SP_JSClock): SP_TimeListener, Controls {

    val root = document.getElementById("sp-root") as HTMLDivElement

    val locationFieldSet = document.createElement("fieldset") as HTMLFieldSetElement
    val locationLegend = document.createElement("legend") as HTMLLegendElement
    val latDegSelect = document.createElement("select") as HTMLSelectElement
    val latMinSelect = document.createElement("select") as HTMLSelectElement
    val latNSSelect = document.createElement("select") as HTMLSelectElement
    val lonDegSelect = document.createElement("select") as HTMLSelectElement
    val lonMinSelect = document.createElement("select") as HTMLSelectElement
    val lonEWSelect = document.createElement("select") as HTMLSelectElement

    val dateFieldSet = document.createElement("fieldset") as HTMLFieldSetElement
    val dateLegend = document.createElement("legend") as HTMLLegendElement

    val timeFieldSet = document.createElement("fieldset") as HTMLFieldSetElement
    val timeLegend = document.createElement("legend") as HTMLLegendElement
    val daySelect = document.createElement("select") as HTMLSelectElement
    val monthSelect = document.createElement("select") as HTMLSelectElement
    val yearSelect = document.createElement("select") as HTMLSelectElement
    val hourSelect = document.createElement("select") as HTMLSelectElement
    val minSelect = document.createElement("select") as HTMLSelectElement
    val secSelect = document.createElement("select") as HTMLSelectElement

    val playPauseButton = document.createElement("button") as HTMLButtonElement
    val nowButton = document.createElement("button") as HTMLButtonElement

    val timeZoneFieldSet = document.createElement("fieldset") as HTMLFieldSetElement
    val timeZoneLegend = document.createElement("legend") as HTMLLegendElement
    val timeZoneHoursSelect = document.createElement("select") as HTMLSelectElement
    val timeZoneMinsSelect = document.createElement("select") as HTMLSelectElement

    val zoomFieldSet = document.createElement("fieldset") as HTMLFieldSetElement
    val zoomLegend = document.createElement("legend") as HTMLLegendElement
    val zoomInButton = document.createElement("button") as HTMLButtonElement
    val zoomOutButton = document.createElement("button") as HTMLButtonElement

    val directionFieldSet = document.createElement("fieldset") as HTMLFieldSetElement
    val directionLegend = document.createElement("legend") as HTMLLegendElement
    val northButton = document.createElement("button") as HTMLButtonElement
    val southButton = document.createElement("button") as HTMLButtonElement
    val eastButton = document.createElement("button") as HTMLButtonElement
    val westButton = document.createElement("button") as HTMLButtonElement

    val rotateFieldSet = document.createElement("fieldset") as HTMLFieldSetElement
    val rotateLegend = document.createElement("legend") as HTMLLegendElement
    val rotateClockwiseButton = document.createElement("button") as HTMLButtonElement
    val rotateAnticlockwiseButton = document.createElement("button") as HTMLButtonElement

    val showFieldSet = document.createElement("fieldset") as HTMLFieldSetElement
    val showLegend = document.createElement("legend") as HTMLLegendElement
    val equGridButton = document.createElement("button") as HTMLButtonElement
    val altazGridButton = document.createElement("button") as HTMLButtonElement

    val showStarsButton = document.createElement("button") as HTMLButtonElement
    val showConstellationsButton = document.createElement("button") as HTMLButtonElement
    val showPlanetsButton = document.createElement("button") as HTMLButtonElement
    val showDSOsButton = document.createElement("button") as HTMLButtonElement
    val showLabelsButton = document.createElement("button") as HTMLButtonElement
    val nightVisionButton = document.createElement("button") as HTMLButtonElement

    val aboutFieldSet = document.createElement("fieldset") as HTMLFieldSetElement
    val aboutLegend = document.createElement("legend") as HTMLLegendElement
    val aboutButton = document.createElement("button") as HTMLButtonElement
    val helpButton = document.createElement("button") as HTMLButtonElement

    val searchFieldSet = document.createElement("fieldset") as HTMLFieldSetElement
    val searchLegend = document.createElement("legend") as HTMLLegendElement
    val searchBox = document.createElement("input") as HTMLInputElement
   // val searchButton = document.createElement("button") as HTMLButtonElement
    val searchSuggestions = document.createElement("div") as HTMLDivElement
    val searchSuggestionsList = document.createElement("div") as HTMLDivElement

    val searchHandler = SearchHandler(sky, cs, this)

    companion object {
        var zoomInc = 0.05
        var rotInc = 5.0 * MathD.DEG_TO_RAD
    }

    fun setupSearchBox() {

        searchBox.setAttribute("type", "text")

      //  searchButton.innerText = "?"
        searchBox.innerText = "Search"

        searchBox.title = "Search for a celestical object"
      //  searchButton.title = "Search for a celestical object"

        searchFieldSet.id="sp-search-set"
        searchLegend.innerText = "Search"

       // searchSuggestions.setAttribute("style", "width:300px;")
        searchSuggestions.className = "autocomplete"

        searchSuggestionsList.style.border = "white 1px solid"
        searchSuggestionsList.style.position = "absolute"
        searchSuggestionsList.style.backgroundColor = "black"
        searchSuggestionsList.style.padding = "5px"
        searchSuggestionsList.style.display = "none"

        searchFieldSet.appendChild(searchLegend)
        searchFieldSet.appendChild(searchSuggestions)
        searchSuggestions.appendChild(searchBox)
      //  searchSuggestions.appendChild(searchButton)
        searchSuggestions.appendChild(searchSuggestionsList)

        searchBox.addEventListener("focus", { e: Event -> searchBoxSelected() })
      //  searchBox.addEventListener("focusout", { e: Event -> searchBoxDeselected(e) })
      //  searchButton.addEventListener("click", { e: Event ->  searchButtonClicked() })

        searchBox.addEventListener("keyup", { e: Event -> searchBoxKeyEventHandler(e) })
        document.addEventListener("click", { e: Event -> documentClicked(e) })

        root.appendChild(searchFieldSet)
    }

    fun documentClicked(e: Event) {
        if ( (e.target != searchSuggestions && e.target !== searchSuggestionsList ) && (e.target !== searchBox) ) {
                searchBoxDeselected()
        }
    }

    fun searchBoxSelected() {

        searchBoxTyping()
    }

    // close search suggestions, except the one passed as an argument
    fun searchBoxDeselected() {
        searchSuggestionsList.innerHTML = ""
        searchSuggestionsList.style.display = "none"
    }

    fun searchBoxKeyEventHandler(e: Event) {

        val keyboardEvent = e as? KeyboardEvent

        if(keyboardEvent != null && keyboardEvent.key === "Enter"){
            searchEntered()
        }
        else {
            searchBoxTyping()
        }
    }

    fun searchBoxTyping() {
        var text = ""

        searchSuggestionsList.innerHTML = ""

        if (searchBox.value != null) {
            text = searchBox.value
        }

        searchSuggestionsList.style.display = "block"

        val suggestions = searchHandler.getSuggestions(text)

        if (suggestions != null && !suggestions.isEmpty()) {
            for (s in suggestions) {
                    val sDiv = document.createElement("div") as HTMLDivElement
                    var sName = s.getSearchableName()
                    var sType = s.getSearchableObjectType()
                    if (sType != "") {
                        sName += " ($sType)"
                    }
                    sDiv.innerHTML = sName
                    sDiv.addEventListener("click", { e: Event -> searchSuggestionSelected(e) })
                    searchSuggestionsList.appendChild(sDiv)
                }
        }
        else if (text == "") {
            val sDiv = document.createElement("div") as HTMLDivElement
            sDiv.innerHTML = "Start typing for suggestions"
            searchSuggestionsList.appendChild(sDiv)
        }
        else {
            val sDiv = document.createElement("div") as HTMLDivElement
            sDiv.innerHTML = "No Suggestions"
            searchSuggestionsList.appendChild(sDiv)
        }
    }

    fun searchSuggestionSelected(e: Event) {

       val suggestion = e.target as HTMLElement

        val sugText = suggestion.innerHTML.toString()
        if(sugText != null && sugText != "No Suggestions" && sugText != "Start typing for suggestions") {
            searchBox.value = sugText
            searchHandler.textSubmit(sugText)
        }

        searchBoxDeselected()
    }

    fun searchEntered() {
        val searchText = searchBox.value

        if(searchText != null) {
            searchHandler.textSubmit(searchText)
        }
    }

    fun setupAboutButton() {
        aboutButton.addEventListener("click", { showAboutInfo() } )

        aboutButton.innerText = "about"
        aboutButton.title = "About this software"
        aboutFieldSet.id="sp-about-set"
        aboutLegend.innerText = "About:"

        aboutFieldSet.appendChild(aboutLegend)
        aboutFieldSet.appendChild(aboutButton)
    }

    fun setupHelpButton() {
        helpButton.addEventListener("click", { showHelpInfo() } )

        helpButton.innerText = "help"
        helpButton.title = "Instructions"
        aboutFieldSet.appendChild(helpButton)
        root.appendChild(aboutFieldSet)
    }

    fun showAboutInfo() {
        window.alert("StarParty.com Night Sky Simulator - Version $VERSION\n" +
                "Copyright Rob Leeson $copyrightDates\n" +
                "For more infomation visit $MORE_INFO_WEBPAGE\n\n" +
                "Please note that no guarantee can be made for the accuracy of this astronomy software. Neither starparty.com nor the developer assumes any liability or responsibility for errors or omissions.")
    }

    fun showHelpInfo() {
        window.alert("The starparty.com Night Sky Simulator shows the stars, constellations, planets and deep-sky objects that are visible in the night sky at the set date, time and location.\n" +
                "\n" +
                "The software will attempt to detect your location.\n" +
                "Alternatively (or if the location detection fails), enter your latitude and longitude in the ‘location’ drop-down controls.\n" +
                "\n" +
                "The Time is shown as UTC (coordinated universal time) unless a timezone is selected to the right of the time controls.\n" +
                "The timer will be running in real time by default. This can be paused with the pause/play button to the right of the timer.\n" +
                "You can set the date and time to any date within the range allowed by the ‘time‘ drop-down controls.\n" +
                "Click ‘Now’ to set the view to the current date and time.\n" +
                "\n" +
                "The horizon is shown as a green line.\n" +
                "The zenith and the nadir (where the blue grid lines converge) show the points directly overhead and beneath the observer, respectively.\n" +
                "\n" +
                "Drag to move around the zenith.\n" +
                "Use the mouse wheel, zoom buttons, or pinch to zoom in and out.\n" +
                "\n" +
                "Click your browser‘s refresh button to reset the view.")
    }

    fun setupZoomButtons() {

        zoomInButton.addEventListener("click", { zoomChanged(zoomInc) })
        zoomOutButton.addEventListener("click", { zoomChanged(-zoomInc) })

        zoomInButton.innerText = "in"
        zoomOutButton.innerText = "out"

        zoomInButton.title = "Zoom In"
        zoomOutButton.title = "Zoom Out"

        zoomFieldSet.id="sp-zoom-set"
        zoomLegend.innerText = "Zoom:"
        zoomFieldSet.appendChild(zoomLegend)
        zoomFieldSet.appendChild(zoomInButton)
        zoomFieldSet.appendChild(zoomOutButton)
        root.appendChild(zoomFieldSet)
    }

    fun setupRotateButtons() {

        rotateClockwiseButton.addEventListener("click", { rotationChanged(-rotInc) })
        rotateAnticlockwiseButton.addEventListener("click", { rotationChanged(rotInc) })

        rotateClockwiseButton.innerText = "\u21BB"
        rotateAnticlockwiseButton.innerText = "\u21BA"

        rotateClockwiseButton.title = "Rotate Clockwise"
        rotateAnticlockwiseButton.title = "Rotate Anticlockwise"

        rotateFieldSet.id="sp-rotation-set"
        rotateLegend.innerText = "Rotate:"
        rotateFieldSet.appendChild(rotateLegend)
        rotateFieldSet.appendChild(rotateClockwiseButton)
        rotateFieldSet.appendChild(rotateAnticlockwiseButton)
        root.appendChild(rotateFieldSet)
    }

    fun setupDirectionButtons() {

        northButton.addEventListener("click", { directionChanged(0.0) })
        eastButton.addEventListener("click", { directionChanged(PI/2.0) })
        southButton.addEventListener("click", { directionChanged(PI) })
        westButton.addEventListener("click", { directionChanged(PI*(3.0/2.0)) })

        northButton.innerText = "N"
        eastButton.innerText  = "E"
        southButton.innerText = "S"
        westButton.innerText  = "W"

        northButton.title = "Face North"
        eastButton.title  = "Face East"
        southButton.title = "Face South"
        westButton.title  = "Face West"

        directionFieldSet.id="direction"
        directionLegend.innerText = "Direction:"
        directionFieldSet.appendChild(directionLegend)
        directionFieldSet.appendChild(northButton)
        directionFieldSet.appendChild(eastButton)
        directionFieldSet.appendChild(southButton)
        directionFieldSet.appendChild(westButton)
        root.appendChild(directionFieldSet)
    }

    fun setupShowButtons() {

        equGridButton.addEventListener("click", { equGridChanged()  })
        altazGridButton.addEventListener("click", { altazGridChanged() })

        equGridButton.innerText = "Eq"
        altazGridButton.innerText  = "AA"

        equGridButton.title  = "Switch Equatorial Grid Type"
        altazGridButton.title  = "Switch Horizontal (Altitude/Azimuth) Grid Type"

        showFieldSet.id="show"
        showLegend.innerText = "Show:"
        showFieldSet.appendChild(showLegend)
        showFieldSet.appendChild(equGridButton)
        showFieldSet.appendChild(altazGridButton)

        showStarsButton.addEventListener("click", { showStarsChanged() })
        showPlanetsButton.addEventListener("click", { showPlanetsChanged() })
        showDSOsButton.addEventListener("click", { showDSOsChanged() })
        showConstellationsButton.addEventListener("click", { showConstellationsChanged() })
        showLabelsButton.addEventListener("click", { showLabelsChanged() })

        nightVisionButton.addEventListener("click", { nightVisionToggled() })

        showStarsButton.innerText = "\u2605"
        showDSOsButton.innerText  = "M"
        showPlanetsButton.innerText = "Planets"
        showConstellationsButton.innerText  = "Const"
        showLabelsButton.innerText = "Labels"

        nightVisionButton.innerText = "Night Vision"

        showStarsButton.title = "Show/Hide Stars"
        showDSOsButton.title  = "Show/Hide Messier Objects"
        showPlanetsButton.title = "Show/Hide Planets, Sun and Moon"
        showConstellationsButton.title  = "Switch Between Constellation Lines and Boundaries"
        showLabelsButton.title = "Show object names - Full/Abbreviated/Off"

        nightVisionButton.title = "Toggle Night Vision Colours"

        showFieldSet.appendChild(showStarsButton)
        showFieldSet.appendChild(showDSOsButton)
        showFieldSet.appendChild(showPlanetsButton)
        showFieldSet.appendChild(showConstellationsButton)
        showFieldSet.appendChild(showLabelsButton)
        showFieldSet.appendChild(nightVisionButton)

        root.appendChild(showFieldSet)
    }

    fun nightVisionToggled()
    {
        val nvOn = cs.toggleNightVisionTheme()

        changeFieldSetColours(nvOn, locationLegend, locationFieldSet)
        changeFieldSetColours(nvOn, dateLegend, dateFieldSet)
        changeFieldSetColours(nvOn, timeLegend, timeFieldSet)
        changeFieldSetColours(nvOn, timeZoneLegend, timeZoneFieldSet)
        changeFieldSetColours(nvOn, zoomLegend, zoomFieldSet)
        changeFieldSetColours(nvOn, directionLegend, directionFieldSet)
        changeFieldSetColours(nvOn, rotateLegend, rotateFieldSet)
        changeFieldSetColours(nvOn, showLegend, showFieldSet)
        changeFieldSetColours(nvOn, aboutLegend, aboutFieldSet)
        changeFieldSetColours(nvOn, searchLegend, searchFieldSet)
        changeSearchBoxColours(nvOn)
        changeBackgroundColours(nvOn)

        cs.sky.project()
        cs.changed = true
        cs.draw()
    }

    fun changeBackgroundColours(nvOn: Boolean) {
        if (nvOn) {
            root.className = "sp-root-bg-image-night-vision"
        }
        else {
            root.className = "sp-root-bg-image"
        }
    }

    fun changeSearchBoxColours(nvOn: Boolean){

        var colour = ""
        if (nvOn) {
            colour = "red"
        }

        searchBox.style.backgroundColor = colour
        searchSuggestions.style.color = colour
        searchSuggestionsList.style.borderColor = colour

    }

    fun changeFieldSetColours(nvOn: Boolean, legend: HTMLLegendElement, fieldSet: HTMLFieldSetElement){

        var childBGColour = ""
        var fieldSetBGColor = ""

        if (nvOn) {
            childBGColour = "red"
            fieldSetBGColor = "black"
        }

        fieldSet.style.borderColor = childBGColour
        fieldSet.style.backgroundColor = fieldSetBGColor
        legend.style.color = childBGColour

        val children = fieldSet.children

        var c = 1
        while (c < children.length) {
            val child = children[c] as HTMLElement
            child.style.backgroundColor = childBGColour
            c++
        }

    }

    fun showLabelsChanged() {

        cs.sky.showLabels++

        if (cs.sky.showLabels > Sky.ABBR_TITLES) {
                cs.sky.showLabels = Sky.NO_TITLES
        }

        cs.sky.project()
        cs.changed = true
        cs.draw()
    }

    fun rotationChanged(rotInc: Double) {

        cs.sky.roll(rotInc)
        cs.sky.project()
        cs.changed = true
        cs.draw()
    }

    fun zoomChanged(zoomInc: Double) {

        cs.incrementZoomFromCanvasCentre(1 + zoomInc)
        cs.sky.project()
        cs.changed = true
        cs.draw()
    }

    fun equGridChanged(){
        cs.sky.rotateEquatorialGridType()
        cs.changed = true
        cs.draw()
    }

    fun altazGridChanged(){
        cs.sky.rotateAltAzmGridType()
        cs.changed = true
        cs.draw()
    }

    fun showStarsChanged(){
        cs.sky.starField.isShowingStars = ! cs.sky.starField.isShowingStars
        cs.changed = true
        cs.draw()
    }

    fun showPlanetsChanged(){
        cs.sky.orrery.isShowingObjects = ! cs.sky.orrery.isShowingObjects
        cs.changed = true
        cs.draw()
    }

    fun showDSOsChanged(){
        cs.sky.deepSkyField.isShowingDSOs = ! cs.sky.deepSkyField.isShowingDSOs
        cs.changed = true
        cs.draw()
    }

    fun showConstellationsChanged(){

        cs.sky.rotateConstellationType()
        cs.changed = true
        cs.draw()
    }


    fun directionChanged(direction: Double) {

        cs.sky.setAltAzmCoordinatesWithZenithUp(direction, 0.0)

        cs.sky.project()
        cs.changed = true
        cs.draw()
    }

    fun setTimeToNow() {
        clock.pause()
        dateTime = initialiseDateTime()
        cs.sky.setTime(dateTime)
        syncDateTimeSpinners()

        if (playPauseButton.innerText == "=") {
            clock.start(dateTime)
        }
    }

    fun playClicked(){

        val playing = playPauseButton.textContent == "="

        if (playing) {
            playPauseButton.textContent = "⏵"
            playPauseButton.id = "play-button"
            clock.pause()
            playPauseButton.title = "Start Timer"
        }
        else {
            playPauseButton.textContent = "="
            playPauseButton.id = "pause-button"
            clock.start(cs.sky.getTime())
            playPauseButton.title = "Pause Timer"
        }
    }

    fun setupDateTimeControls(timeZoneOffsetHours: Int, timeZoneOffsetMins: Int) {

        val tzoHours = timeZoneOffsetHours.toString()
        val tzoMins = timeZoneOffsetMins.toString()
        val curTime = cs.sky.getTime()

        val year = curTime.yearUTC()
        val earliestYear = year - 20
        val latestYear = year + 20

        addTimeZoneOptions()
        timeZoneHoursSelect.value = tzoHours
        timeZoneMinsSelect.value = tzoMins

        addNumberedOptions(daySelect, 1, 31, "", 0, true)
        addMonthOptions(monthSelect)
        addNumberedOptions(yearSelect, earliestYear, latestYear, "", 0, false)

        addNumberedOptions(hourSelect, 0, 23, "", 0, true)
        addNumberedOptions(minSelect, 0, 59, "", 0, true)
        addNumberedOptions(secSelect, 0, 59, "", 0, true)

        daySelect.addEventListener("change", { timeSpinnerChanged() })
        monthSelect.addEventListener("change", { timeSpinnerChanged() })
        yearSelect.addEventListener("change", { timeSpinnerChanged() })

        hourSelect.addEventListener("change", { timeSpinnerChanged() })
        minSelect.addEventListener("change", { timeSpinnerChanged() })
        secSelect.addEventListener("change", { timeSpinnerChanged() })

        timeZoneHoursSelect.addEventListener("change", { syncDateTimeSpinners() })
        timeZoneMinsSelect.addEventListener("change", { syncDateTimeSpinners() })

        nowButton.addEventListener("click", { setTimeToNow() })
        playPauseButton.addEventListener("click", { playClicked() } )

        setTimeToNow()

        dateFieldSet.id = "sp-date-set"
        dateFieldSet.appendChild(dateLegend)
        dateLegend.innerText = "Date:"
        dateFieldSet.appendChild(daySelect)
        dateFieldSet.appendChild(monthSelect)
        dateFieldSet.appendChild(yearSelect)

        timeFieldSet.id = "sp-time-set"
        timeFieldSet.appendChild(timeLegend)
        timeLegend.innerText = "Time:"
        timeFieldSet.appendChild(hourSelect)
        timeFieldSet.appendChild(minSelect)
        timeFieldSet.appendChild(secSelect)

        nowButton.textContent = "Now"
        nowButton.title = "Set to Current Date and Time"

        playPauseButton.textContent = "="
        playPauseButton.id = "pause-button"
        playPauseButton.title = "Pause Timer"

        timeFieldSet.appendChild(playPauseButton)
        timeFieldSet.appendChild(nowButton)

        timeZoneLegend.innerText = "Time Zone:"
        timeZoneFieldSet.appendChild(timeZoneLegend)
        timeZoneFieldSet.appendChild(timeZoneHoursSelect)
        timeZoneFieldSet.appendChild(timeZoneMinsSelect)

        root.appendChild(dateFieldSet)
        root.appendChild(timeFieldSet)
        root.appendChild(timeZoneFieldSet)
    }

    fun setupLocationSpinners() {

        val curPlace = cs.sky.getPlace()
        val dmsLat = UMS.degreesToDMS(curPlace.latitude)
        val dmsLon = UMS.degreesToDMS(curPlace.longitude)
        val latDeg = abs(dmsLat.units.toInt())
        val latMin = dmsLat.mins.toInt()
        val lonDeg = abs(dmsLon.units.toInt())
        val lonMin = dmsLon.mins.toInt()

        addNumberedOptions(latDegSelect, 0, 90, "°", latDeg, false)
        addNumberedOptions(latMinSelect, 0, 59, "m", latMin, true)

        addNumberedOptions(lonDegSelect, 0, 180, "°", lonDeg, false)
        addNumberedOptions(lonMinSelect, 0, 59, "m", lonMin, true)
        // addNumberedOptions("sp-lon-sec",1, 59, "s")

        addNSEWOptions()

        if (curPlace.latitude < 0) {
            latNSSelect.selectedIndex = 1
        }
        if (curPlace.longitude < 0) {
            lonEWSelect.selectedIndex = 1
        }

        latDegSelect.addEventListener("change", { locationChanged() })
        latMinSelect.addEventListener("change", { locationChanged() })
        latNSSelect.addEventListener("change", { locationChanged() })

        lonDegSelect.addEventListener("change", { locationChanged() })
        lonMinSelect.addEventListener("change", { locationChanged() })
        lonEWSelect.addEventListener("change", { locationChanged() })

        locationFieldSet.id = "sp-loc-set"
        locationFieldSet.appendChild(locationLegend)
        locationLegend.innerText = "Location:"
        locationFieldSet.appendChild(latDegSelect)
        locationFieldSet.appendChild(latMinSelect)
        locationFieldSet.appendChild(latNSSelect)
        locationFieldSet.appendChild(lonDegSelect)
        locationFieldSet.appendChild(lonMinSelect)
        locationFieldSet.appendChild(lonEWSelect)
        root.appendChild(locationFieldSet)
    }


    fun addNumberedOptions(
        select: HTMLSelectElement,
        startNum: Int,
        finishNum: Int,
        unit: String,
        selectedOption: Int,
        leadingZeros: Boolean
    ) {

        for (i in startNum..finishNum) {
            val sel = (i == selectedOption)
            var text = "$i$unit"

            if (leadingZeros && (i in 0..9)) {
                text = "0$text"
            }
            val option = Option(text, i.toString(), false, sel)
            select.options.add(option)
        }
    }

    fun addTimeZoneOptions()
    {
        /*
        val options = arrayOf(
            Option("UTC+14","14"),
            Option("UTC+13","13"),
            Option("UTC+12:45", "12.75"),
            Option("UTC+12", "12"),
            Option("UTC+11", "11"),
            Option("UTC+10:30", "10.5"),
            Option("UTC+10", "10"),
            Option("UTC+9:30", "9.5"),
            Option("UTC+9", "9"),
            Option("UTC+8", "8"),
            Option("UTC+7", "7"),
            Option("UTC+6:30", "6.5"),
            Option("UTC+6", "6"),
            Option("UTC+5:45", "5.75"),
            Option("UTC+5:30", "5.5"),
            Option("UTC+5", "5"),
            Option("UTC+4:30", "4.5"),
            Option("UTC+4", "4"),
            Option("UTC+3", "3"),
            Option("UTC+2", "2"),
            Option("UTC+1", "1"),
            Option("UTC+0", "0", true, true),
            Option("UTC-1", "-1"),
            Option("UTC-2", "-2"),
            Option("UTC-2:30", "-2.5"),
            Option("UTC-3", "-3"),
            Option("UTC-4", "-4"),
            Option("UTC-5", "-5"),
            Option("UTC-6", "-6"),
            Option("UTC-7", "-7"),
            Option("UTC-8", "-8"),
            Option("UTC-9", "-9"),
            Option("UTC-9:30", "-9.5"),
            Option("UTC-10", "-10"),
            Option("UTC-11", "-11"),
            Option("UTC-12", "-12")
        ) */

        for (i in -14..14) {
            val sign = if (i >= 0) "+" else ""
            val option = Option("UTC$sign$i hrs", i.toString())
           timeZoneHoursSelect.options.add(option)
        }

        timeZoneMinsSelect.options.add(Option("00 mins", "0"))
        timeZoneMinsSelect.options.add(Option("15 mins", "15"))
        timeZoneMinsSelect.options.add(Option("30 mins", "30"))
        timeZoneMinsSelect.options.add(Option("45 mins", "45"))
    }

    fun addNSEWOptions() {

        val optionE = Option("E", "E")
        val optionW = Option("W", "W")
        val optionN = Option("N", "N")
        val optionS = Option("S", "S")
        lonEWSelect.options.add(optionE)
        lonEWSelect.options.add(optionW)
        latNSSelect.options.add(optionN)
        latNSSelect.options.add(optionS)
    }

    fun addMonthOptions(select: HTMLSelectElement) {

        val months = arrayOf("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec")
        for (i in 0..11) {
            val option = Option(months[i], i.toString())
            select.options.add(option)
        }
    }

    fun syncDateTimeSpinners() {

        val curTime = cs.sky.getTime()

        val day = curTime.dayOfMonthUTC()
        val month = curTime.monthUTC() - 1
        val year = curTime.yearUTC()

        val hour = curTime.hourOfDayUTC()
        val min = curTime.minuteUTC()
        val sec = curTime.secondUTC()

        val tzoHrs = timeZoneHoursSelect.value.toDouble()
        val tzoSign = if (tzoHrs < 0) -1 else 1
        val tzoMins = timeZoneMinsSelect.value.toDouble()
        val timeZoneSecondsOffset = tzoSign * ((tzoHrs.absoluteValue * 60 * 60)  + (tzoMins * 60))

        val jsDT_zoned = Date(year, month, day, hour, min, sec+timeZoneSecondsOffset.toInt())

        yearSelect.value = jsDT_zoned.getFullYear().toString()
        monthSelect.selectedIndex = jsDT_zoned.getMonth()
        daySelect.selectedIndex = jsDT_zoned.getDate() - 1
        hourSelect.selectedIndex = jsDT_zoned.getHours()
        minSelect.selectedIndex = jsDT_zoned.getMinutes()
        secSelect.selectedIndex = jsDT_zoned.getSeconds()

       // timeZoneHoursSelect.selectedIndex = tzoHrs.toInt()
       // timeZoneMinsSelect.selectedIndex = tzoMins.toInt()

        cs.sky.project()
        cs.changed = true
        cs.draw()
    }


    fun timeSpinnerChanged() {

        clock.pause()

        val day = daySelect.value.toInt()
        val month = monthSelect.value.toInt()
        val year = yearSelect.value.toInt()

        val hour = hourSelect.value.toInt()
        val min = minSelect.value.toInt()
        val sec = secSelect.value.toInt()

        val tzoHours = timeZoneHoursSelect.value.toDouble() * 60 * 60
        val tzoMins = timeZoneMinsSelect.value.toDouble() * 60
        val tzoSign = if (tzoHours < 0) 1 else -1
        val timeZoneSecondsOffset = tzoSign * (tzoHours + tzoMins)

        val jsDT_zoned = Date(year, month, day, hour, min, sec)

        val jsDT_UTC = Date(year, month, day, hour, min, sec+timeZoneSecondsOffset.toInt())

        val utcYear = jsDT_UTC.getFullYear()
        val utcMonth = jsDT_UTC.getMonth()
        val utcDay = jsDT_UTC.getDate()
        val utcHour = jsDT_UTC.getHours()
        val utcMin = jsDT_UTC.getMinutes()
        val utcSec = jsDT_UTC.getSeconds()
        val utcMS = jsDT_UTC.getMilliseconds()

        val spTime = SP_JSTime(utcYear, utcMonth + 1, utcDay, utcHour, utcMin, utcSec, utcMS)

        yearSelect.value = jsDT_zoned.getFullYear().toString()
        monthSelect.selectedIndex = jsDT_zoned.getMonth()
        daySelect.selectedIndex = jsDT_zoned.getDate() - 1
        hourSelect.selectedIndex = jsDT_zoned.getHours()
        minSelect.selectedIndex = jsDT_zoned.getMinutes()
        secSelect.selectedIndex = jsDT_zoned.getSeconds()

        cs.sky.setTime(spTime)

        cs.sky.project()
        cs.changed = true
        cs.draw()

        if (playPauseButton.innerText == "=") {
            clock.start(spTime)
        }
    }


    fun locationChanged() {
/*
        val latDegSelect = document.getElementById("sp-lat-deg") as HTMLSelectElement
        val latMinSelect = document.getElementById("sp-lat-min") as HTMLSelectElement
        val latNSSelect = document.getElementById("sp-lat-NS") as HTMLSelectElement

        val lonDegSelect = document.getElementById("sp-lon-deg") as HTMLSelectElement
        val lonMinSelect = document.getElementById("sp-lon-min") as HTMLSelectElement
        val lonEWSelect = document.getElementById("sp-lon-EW") as HTMLSelectElement
*/

        val latDeg = latDegSelect.value.toDouble()
        val latMin = latMinSelect.value.toDouble()
        val latNS = latNSSelect.value

        val lonDeg = lonDegSelect.value.toDouble()
        val lonMin = lonMinSelect.value.toDouble()
        val lonEW = lonEWSelect.value

        var latSign = 1
        var lonSign = 1
        if ("S" == latNS) { latSign = -1 }
        if ("W" == lonEW) { lonSign = -1 }

        val lat = UMS.unitMinSecToDecimal(latSign, latDeg, latMin, 0.0)
        val lon = UMS.unitMinSecToDecimal(lonSign, lonDeg, lonMin, 0.0)

        cs.sky.setLat(lat)
        cs.sky.setLon(lon)

        cs.sky.setAltAzmCoordinatesWithZenithUp(0.0, 0.0)

        cs.sky.project()
        cs.changed = true
        cs.draw()
    }

    fun setupCanvas() {

        val htmlCanvas = cs.spCanvas.canvas
        val spCanvas = cs.spCanvas
        val controlsHeight = root.offsetHeight

        root.appendChild(htmlCanvas)

        val ctx = htmlCanvas.getContext("2d") as CanvasRenderingContext2D
        ctx.canvas.width  = window.innerWidth //- 10
        ctx.canvas.height = window.innerHeight - controlsHeight - 10
        ctx.canvas.setAttribute("style", "overflow:hidden")

        val xOffset = spCanvas.width / 2.0
        val yOffset = spCanvas.height * (4.5/5.0)
        spCanvas.translate(xOffset, yOffset)
    }

    override fun timeChanged(event: SP_TimeEvent) {
    //    val newTime = initialiseDateTime()
        val dt = event.deltaT
        val startTime = event.startTime

        val newTimeStamp = toTimeStamp(startTime) + dt

        val newTime = createTime(newTimeStamp)

        cs.sky.setTime(newTime)

        syncDateTimeSpinners()
    }

    override fun stopTrackingSenorOrientation() {
// Not yet used.
    }

}